jQuery(document).ready(function($){

  $('.postcode_check_grid .posthead .postcode-form-toggle-switch').on('click', function(e){
    e.preventDefault();
    $('#post_check_form').show();
  })

  /* $.ajax({
    url: 'https://sbz.cirkleinc.com/front-widget',
    type: 'POST',
    data: {
      rate: {
        destination: {
          postal_code: '4110',
          province: '',
          country: ''
        },
        items: [
          {
            product_id: '8848385409320',
            variant_id: '47441361568040',
            sku: 'CL-WB193-K',
            type: 'Beds & Bed Frames',
            tag: 'Bed Base,Bed Frames,Clearance,color_Natural,material_Timber,parent_bedroom,parent_kidsroom,size_double,size_king,size_king single,size_queen,size_single,style_Bohemian,style_Coastal,style_Scandinavian,types_Bed Base',
            name: 'Cali Bed Base',
            quantity: 1,
            grams: 30790,
            price: 32900,
            vendor: 'Lifely'
          }
        ]
      },
      shop: 'kstack-lifely-staging.myshopify.com'
    },
    success: function(response) {
      console.log('Success:', response);
    },
    error: function(xhr, status, error) {
      console.error('Error:', error);
    }
  }); */
  

  
  // $('.ajax-cart-item__total span:first').text('Subtotal');
  const cont = jQuery('#zooomy-head-wishlist-icon').html();
  jQuery('#heart-icon-bubble').append(cont); 
  jQuery('.ajax-cart-item__total').insertBefore('.custom_mini_cart_total_main .ajax-cart-item__total:eq(1)');
  // Move the element with class 'ajax-cart-item__total_with_original' to the third position
  jQuery('.ajax-cart-item__total_with_original').insertBefore('.free-shipping-grid');
  $('.quantity-avl').each(function() {
    if ($(this).text().trim() === '') {
        $(this).hide();
    }
  });


  setTimeout(function(){
    var counter_html; 

    if($('#heart-icon-bubble #zooomy-wishlist-counter').length > 0){
      if($('#heart-icon-bubble #zooomy-wishlist-counter span').length > 0){
        counter_html = $('#heart-icon-bubble #zooomy-wishlist-counter span');
        if(counter_html.length > 0){
          $('#heart-icon-bubble #zooomy-wishlist-counter').addClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').show();
          $('#heart-icon-bubble #zooomy-wishlist-counter span').show();
        }else{
          $('#heart-icon-bubble #zooomy-wishlist-counter').removeClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').hide();
        }
      }else{
        counter_html = $('#heart-icon-bubble #zooomy-wishlist-counter').html();
        if(counter_html.length > 0){
          $('#heart-icon-bubble #zooomy-wishlist-counter').addClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').show();
        }else{
          $('#heart-icon-bubble #zooomy-wishlist-counter').removeClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').hide();
        }
      }
    }
    
  }, 1200);
  
  
  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-plus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity;
    if(quantity != '' && quantity != 'undefined'){
      old_quantity = $('.product_custom_cart_qty').val();
      if(old_quantity !== false && typeof old_quantity !== 'undefined'){
        new_quantity = parseInt(old_quantity)+ parseInt(1);
        $('.product_custom_cart_qty').val(new_quantity);
      }
    }
  }) 

  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-minus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity; 
    if(quantity != '' && quantity != 'undefined'){
      if($(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val() > 1){
        old_quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
        if(old_quantity != '' && old_quantity != 'undefined' && old_quantity > 0){
          new_quantity = parseInt(old_quantity)-parseInt(1);
          $('.product_custom_cart_qty').val(new_quantity);
         } 
      }
    }
  }) 
  
  /* $('.quantity .button-cart-plus').on('click', function(){
    var quantity = $(this).prev().val();
    var new_quantity;
    var old_quantity;
    if(quantity != '' && quantity != 'undefined'){
      old_quantity = $(this).prev().val();
      if(old_quantity !== false && typeof old_quantity !== 'undefined'){
        new_quantity = parseInt(old_quantity)+ parseInt(1);
        //$(this).prev().val(new_quantity)
        $(this).closest('.quantity').find('input.quantity__input').val(new_quantity);
        $(this).closest('.quantity').find('input.quantity__input').trigger('change');
      }
    }   
  }) 

  $('.quantity .button-cart-minus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity; 
    if(quantity != '' && quantity != 'undefined'){
      console.log($(this).next().val())
      if($(this).next().val() > 1){
        old_quantity = $(this).next().val();
        if(old_quantity != '' && old_quantity != 'undefined' && old_quantity > 0){
            new_quantity = parseInt(old_quantity)-parseInt(1);
            $('.quantity__input').val(new_quantity)
            console.log(new_quantity)
        } 
      }
    }
    $('.quantity__input').focus();
  }) */

   $("fieldset.js.product-form__input input[type='radio']").on("click", function() {
     setTimeout(function(){
     var regularPrice = $(".price__sale .price-item--regular").text().trim().replace(" AUD", "");
     $("input[name='properties[Full-price]']").val(regularPrice);
     console.log(regularPrice)
    }, 1000)
       var selectedValue = $(this).val();
    setTimeout(function(){
      var price = $('.shopify_price_container .price__sale .price-item.price-item--sale.price-item--last').text()
      var consoleOutputText = price;
          // Split the text by space character
      var values = consoleOutputText.split(" ");
      
      // Find the index of the first element that contains the price
      var firstPriceIndex = values.findIndex(function(element) {
        return element.includes("$");
      });
      
      // Get the first price from the array
      var firstPrice = values[firstPriceIndex];
       // Convert the price string to a number and apply the 15% discount
      var priceWithoutCurrency = parseFloat(firstPrice.replace(/[^\d.]/g, ''));
      if ($('.mid-sale-discount-batches').hasClass('mattress-deep-dream-offer')) {
          // console.log('3333333333330000000000000')
        var discountedPrice = priceWithoutCurrency * 0.80;
        console.log(discountedPrice)
      }else if ($('.dicount-pernt').hasClass('25%')) {
        var discountedPrice = priceWithoutCurrency * 0.75;
      }else{
        var discountedPrice = priceWithoutCurrency * 0.80;
      }
      // var discountedPrice = priceWithoutCurrency * 0.80;
      console.log(values)
      console.log("First price:", firstPrice);
      // if ($('body').hasClass('product-6822546636842')) {  
      //   if(selectedValue == 'Queen'){
      //     $('.dicount-pernt-30 h4').text('SAVE EXTRA 30% OFF');
      //     $('.dicount-pernt-30 p').text('ON THIS MATTRESS');
      //      $(".product_mattress-deepdream .mid-sale-discount-batches li h4").attr('style', 'color: #FACB07 !important');
      //     $(".product_mattress-deepdream .mid-sale-discount-batches li p").attr('style', 'color: #FACB07 !important');
      //     $(".product_mattress-deepdream .custom-price h5 ").attr('style', 'color: #FACB07 !important');
      
      //     $('.product_mattress-deepdream .mid-sale-discount-batches').attr('style', 'background: #192e59 !important');
      //     var discountedPrice = priceWithoutCurrency * 0.70;
      //   }else{
      //      $(".product_mattress-deepdream .mid-sale-discount-batches li h4").removeAttr('style');
      //     $(".product_mattress-deepdream .mid-sale-discount-batches li p").removeAttr('style');
      //     $(".product_mattress-deepdream .custom-price h5 ").removeAttr('style');
      
      //     $('.product_mattress-deepdream .mid-sale-discount-batches').removeAttr('style');
      //     $('.dicount-pernt-30 h4').text('SAVE EXTRA 20% OFF')
      //     var discountedPrice = priceWithoutCurrency * 0.80;
      //   }
      // }else{
      //   console.log('111111111111')
      // }
      $('.custom-price').find('h5').text("$" + discountedPrice.toFixed(2));
    }, 1000)
  });
  
  setTimeout(function(){
    jQuery('.custom_mini_cart_total .new_subtotal-grid').show();
  }, 2000)

   // When a radio button in the "Size" fieldset is clicked
  $("fieldset.js.product-form__input input[name='Size']").click(function () {
    // Check if none is selected in the "Color" fieldset and set the first option if none is selected
    let colorFieldsetRadios = $("fieldset.js.product-form__input.color_option_field input[name='Color']");
    if (colorFieldsetRadios.filter(':checked').length === 0) {
        colorFieldsetRadios.first().prop('checked', true);
      var val = colorFieldsetRadios.first().val();
      jQuery('variant-radios .product-form__input input[name="Color"]:checked').closest('.product-form__input').find('legend.form__label').html('Color: <span class="color_slected">'+val+'</span>');
      colorFieldsetRadios.first().addClass('click7777777777');
    }
  });

  // When a radio button in the "Color" fieldset is clicked
  $("fieldset.js.product-form__input.color_option_field input[name='Color']").click(function () {
    // Check if none is selected in the "Size" fieldset and set the first option if none is selected
    let sizeFieldsetRadios = $("fieldset.js.product-form__input input[name='Size']");
    if (sizeFieldsetRadios.filter(':checked').length === 0) {
        sizeFieldsetRadios.first().prop('checked', true);
      sizeFieldsetRadios.first().trigger('click');
    }
  });
 ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
 $(document).mouseup(function (e) {
    // Check if opt-notifications opt-shadow has the class active
    if ($('.opt-notifications.opt-shadow').hasClass('active')) {
        var container = $(".recent_view_product_inner");

        // Check if the target of the click is not the container or its descendants
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            console.log('Clicked outside .recent_view_product_inner');
            // Hide the popup
            $('.opt-notifications_button').trigger('click')
        }
    }
});
  
 // Function to check if .quantity-avl span is blank
function checkQuantityAvl() {
    if ($.trim($('.quantity-avl').text()) === '') {
        console.log('.quantity-avl span is blank');
        $('#ISR_button').hide();
    } else {
        $('#ISR_button').hide(); // Show the button if needed
        console.log('.quantity-avl span is not blank');
    }
}

// MutationObserver configuration
const observerConfig = { childList: true, subtree: true };

// Callback function to handle mutations
const mutationCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Check if .quantity-avl span is present after a mutation
            if ($('.quantity-avl').length > 0) {
                // Stop observing once the element is found
                observer.disconnect();
                // Check if .quantity-avl span is blank
                checkQuantityAvl();
            }
        }
    }
};

// Select the target node (parent of .quantity-avl span)
const targetNode = document.querySelector('.dispatch_deatil');

// Check if the target node exists before observing
if (targetNode) {
    // Create a MutationObserver instance with the callback and configuration
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for mutations
    observer.observe(targetNode, observerConfig);
} else {
    console.log("Target node not found");
}
  ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
  // Check if the delivery_date contains 'Not Eligible'
  function updateDeliveryDate() {
    // Check if the delivery_date contains 'Not Eligible'
    var deliveryDateElement = document.querySelector('.delivery_date');
    if (deliveryDateElement && deliveryDateElement.textContent.trim() === 'Not Eligible') {
        // If 'Not Eligible', get the dispatch_date and add one day to it
        var dispatchDateElement = document.querySelector('.dispatch_date');
        if (dispatchDateElement) {
            var dispatchDate = new Date(dispatchDateElement.textContent.trim());

            // Add one day to the dispatch date
            dispatchDate.setDate(dispatchDate.getDate() + 1);

            // Format the new date as 'Day Month Year' (e.g., 14 December 2023)
            var day = dispatchDate.getDate();
            var month = dispatchDate.toLocaleString('default', { month: 'long' });
            var year = dispatchDate.getFullYear();

            // Construct the formatted date
            var formattedDate = day + ' ' + month + ' ' + year;

            // Update the delivery_date with the new date
            deliveryDateElement.textContent = formattedDate;
        }
    }
}
  setTimeout(function(){
    // Check if the delivery_date contains 'Not Eligible'
    updateDeliveryDate();
  }, 5000)
 
  
})